const getCharacterCount = (value, maxLength, showCharacterCount) => {
  if (!showCharacterCount || !maxLength) {
    return null;
  }

  return `${(value || '').length}/${maxLength}`;
};

export default getCharacterCount;
